var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollegeType3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 497.261 497.261",
    style: {
      enableBackground: "new 0 0 497.261 497.261"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D0D1D1"
    },
    points: "402.23,8.145 95.03,8.145 8.145,171.055 489.115,171.055 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#193651"
    },
    d: "M489.115,178.812H8.145c-3.103,0-5.43-1.552-6.982-3.879s-1.552-5.43,0-7.758L88.048,4.267 c1.552-2.327,3.879-3.879,6.982-3.879h307.2c3.103,0,5.43,1.552,6.982,3.879l86.885,162.909c1.552,2.327,1.552,5.43,0,7.758 C494.545,178.036,492.218,178.812,489.115,178.812z M21.333,163.297h455.37L397.576,15.903H99.685L21.333,163.297z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "60.121,140.024 113.648,39.176 383.612,39.176 437.139,140.024 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDBE5E"
    },
    points: "248.63,60.121 140.024,171.055 140.024,448 357.236,448 357.236,171.055 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#193651"
    },
    d: "M357.236,455.758H140.024c-4.655,0-7.758-3.103-7.758-7.758V171.055c0-2.327,0.776-3.879,2.327-5.43 L243.2,54.691c3.103-3.103,8.533-3.103,10.861,0l108.606,110.933c1.552,1.552,2.327,3.103,2.327,5.43V448 C364.994,452.655,361.891,455.758,357.236,455.758z M147.782,440.242h201.697V174.158L248.63,70.982L147.782,174.158V440.242z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "171.055,440.242 171.055,184.242 248.63,104.339 326.206,184.242 326.206,440.242  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.539,
    y: 171.055,
    style: {
      fill: "#FFFFFF"
    },
    width: 112.485,
    height: 276.945
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#193651"
    },
    d: "M140.024,455.758H27.539c-4.655,0-7.758-3.103-7.758-7.758V171.055c0-4.655,3.103-7.758,7.758-7.758 h112.485c4.655,0,7.758,3.103,7.758,7.758V448C147.782,452.655,144.679,455.758,140.024,455.758z M35.297,440.242h96.97v-261.43 h-96.97V440.242z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.236,
    y: 171.055,
    style: {
      fill: "#FFFFFF"
    },
    width: 112.485,
    height: 276.945
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#193651"
    },
    d: "M469.721,455.758H357.236c-4.655,0-7.758-3.103-7.758-7.758V171.055c0-4.655,3.103-7.758,7.758-7.758 h112.485c4.655,0,7.758,3.103,7.758,7.758V448C477.479,452.655,473.6,455.758,469.721,455.758z M364.994,440.242h96.97v-261.43 h-96.97V440.242z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 58.57,
    y: 323.103,
    style: {
      fill: "#E1E6E9"
    },
    width: 50.424,
    height: 93.867
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.57,
    y: 202.085,
    style: {
      fill: "#E1E6E9"
    },
    width: 50.424,
    height: 86.109
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.267,
    y: 202.085,
    style: {
      fill: "#E1E6E9"
    },
    width: 50.424,
    height: 86.109
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.267,
    y: 323.103,
    style: {
      fill: "#E1E6E9"
    },
    width: 50.424,
    height: 93.867
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 205.964,
    y: 330.861,
    style: {
      fill: "#2BA1DB"
    },
    width: 86.109,
    height: 117.139
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.673,
    y: 202.085,
    style: {
      fill: "#2BA1DB"
    },
    width: 45.77,
    height: 45.77
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.818,
    y: 202.085,
    style: {
      fill: "#2BA1DB"
    },
    width: 45.77,
    height: 45.77
  })), /*#__PURE__*/React.createElement("rect", {
    x: 8.145,
    y: 448,
    style: {
      fill: "#D0D1D1"
    },
    width: 480.97,
    height: 41.115
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#193651"
    },
    d: "M489.115,496.873H8.145c-4.655,0-7.758-3.103-7.758-7.758V448c0-4.655,3.103-7.758,7.758-7.758 h480.97c4.655,0,7.758,3.103,7.758,7.758v41.115C496.873,493.77,493.77,496.873,489.115,496.873z M15.903,481.358h465.455v-25.6 H15.903V481.358z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.2,
    y: 81.842,
    style: {
      fill: "#193651"
    },
    width: 15.515,
    height: 15.515
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.418,
    y: 81.842,
    style: {
      fill: "#193651"
    },
    width: 15.515,
    height: 15.515
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.327,
    y: 81.842,
    style: {
      fill: "#193651"
    },
    width: 15.515,
    height: 15.515
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.545,
    y: 81.842,
    style: {
      fill: "#193651"
    },
    width: 15.515,
    height: 15.515
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollegeType3);
export default __webpack_public_path__ + "static/media/collegeType-3.4e1228f2472d93e404677e13f35eba11.svg";
export { ForwardRef as ReactComponent };